var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecordNotFoundIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.25 36.25C36.25 37.6307 35.1307 38.75 33.75 38.75H6.25C4.86929 38.75 3.75 37.6307 3.75 36.25V3.75C3.75 2.36929 4.86929 1.25 6.25 1.25H23.965C24.6276 1.25014 25.263 1.5133 25.7317 1.98167L35.5183 11.7683C35.9867 12.237 36.2499 12.8724 36.25 13.535V36.25Z",
    stroke: "#B0E577",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 13.75H26.25C24.8693 13.75 23.75 12.6307 23.75 11.25V1.25",
    stroke: "#B0E577",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 19.3229C11.0659 20.285 12.2217 20.8293 13.43 20.7812C15.3283 20.7812 16.8683 19.6262 16.8683 18.2029C16.8683 16.7796 15.3333 15.6262 13.4367 15.6262C11.54 15.6262 10 14.4712 10 13.0462C10 11.6212 11.54 10.4679 13.4367 10.4679C14.6451 10.4189 15.8013 10.9634 16.5333 11.9262",
    stroke: "#B0E577",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4375 20.7812V22.4996",
    stroke: "#B0E577",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4375 8.75V10.4683",
    stroke: "#B0E577",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25H30",
    stroke: "#B0E577",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 32.5H30",
    stroke: "#B0E577",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordNotFoundIcon);
export default __webpack_public_path__ + "static/media/record-not-found-icon.e1591b7687f73a0abfdac5da9d27c4b8.svg";
export { ForwardRef as ReactComponent };